module.exports = __webpack_public_path__ + "static/media/array-batcher.8cfeca29.png";